import { addMinutes, format } from 'date-fns';
import { MIN_SCHEDULE_MINUTES } from '../constants/whatsapp';

const DATETIME_LOCAL_FORMAT = "yyyy-MM-dd'T'HH:mm";

export function earliestSendTime(): string {
  return format(
    addMinutes(new Date(), MIN_SCHEDULE_MINUTES),
    DATETIME_LOCAL_FORMAT,
  );
}
